import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import search from "/assets/icon/Search.svg";
import axios from "axios";
import Edit from "/Edit.png";
import UserStatus from "../../components/UserStatus";
import EditBranchModal from "../../components/EditBranchModal";
import eyeOpen from "/assets/eyeopen.png";

import "./styles/BranchManagement.css";

function BranchDetails() {
  const location = useLocation();
  const [branch, setBranch] = useState(location.state?.branch);
  const [activeTab, setActiveTab] = useState("users");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [poles, setPoles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSlavePolesModalOpen, setIsSlavePolesModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentSlavePolePage, setCurrentSlavePolePage] = useState(1);
  const slavePolesPerPage = 6; // Adjust as needed
  const [poleDetails, setPoleDetails] = useState(null);

  const openSlavePolesModal = async (poleId) => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/api/poles/${poleId}/details`
      );
      setPoleDetails(response.data); // This assumes the response has both master and slave poles details
      setIsSlavePolesModalOpen(true);
    } catch (error) {
      console.error("Error fetching pole details:", error);
    }
  };

  const closeSlavePolesModal = () => {
    setIsSlavePolesModalOpen(false);
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  useEffect(() => {
    if (branch) {
      const fetchDetails = async () => {
        try {
          const response = await axios.get(
            `${import.meta.env.VITE_API_URL}/api/branches/${branch.id}/details`
          );
          setUsers(response.data.users);
          setPoles(response.data.poles);
        } catch (error) {
          console.error("Error fetching branch details:", error);
        }
      };

      fetchDetails();
    }
  }, [branch]);

  const openEditModal = () => {
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  const [currentPagePoles, setCurrentPagePoles] = useState(1);
  const itemsPerPage = 10;

  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(searchQuery) ||
      user.phone_no.toLowerCase().includes(searchQuery) ||
      user.email.toLowerCase().includes(searchQuery)
  );

  const filteredPoles = poles.filter(
    (pole) =>
      pole.code.toLowerCase().includes(searchQuery) ||
      pole.name.toLowerCase().includes(searchQuery) ||
      pole.location.toLowerCase().includes(searchQuery)
  );

  const currentDataUsers = filteredUsers.slice(
    (currentPageUsers - 1) * itemsPerPage,
    currentPageUsers * itemsPerPage
  );

  const currentDataPoles = filteredPoles.slice(
    (currentPagePoles - 1) * itemsPerPage,
    currentPagePoles * itemsPerPage
  );

  const goToNextPageUsers = () => {
    setCurrentPageUsers((page) => page + 1);
  };

  const goToPreviousPageUsers = () => {
    setCurrentPageUsers((page) => page - 1);
  };

  const goToNextPagePoles = () => {
    setCurrentPagePoles((page) => page + 1);
  };

  const goToPreviousPagePoles = () => {
    setCurrentPagePoles((page) => page - 1);
  };

  const updateBranchSuccess = async (updatedBranch) => {
    try {
      // ทำการอัปเดตข้อมูลสาขาใน state
      setBranch(updatedBranch);
      // ปิดโมดัลหลังจากทำการแก้ไขเสร็จสิ้น
      closeEditModal();
    } catch (error) {
      console.error("Error updating branch:", error);
    }
  };

  return (
    <div className="containerPage">
      <br />
      <br />
      <h1 className="userManagement">
        สาขา {branch.name}
        <img
          src={Edit}
          alt="Edit"
          onClick={openEditModal}
          className="edit-icondetail"
        />
      </h1>
      {isEditModalOpen && (
        <EditBranchModal
          branch={branch}
          closeModal={closeEditModal}
          updateBranchSuccess={updateBranchSuccess} // ส่งฟังก์ชัน updateBranchSuccess เข้าไปใน EditBranchModal
        />
      )}

      {branch ? (
        <div className="branch-details-container">
          <div className="titleb">
            <div>
              <p>สถานะการใช้งาน</p>
              <div className="statusb">
                <UserStatus isOnline={branch.active} />
              </div>
            </div>
            <div className="titlett">
              <p>รหัสสาขา </p>
              <strong>{branch.code}</strong>
            </div>
            <div className="titlett">
              <p>ชื่อสาขา</p>
              <strong>{branch.name}</strong>
            </div>
          </div>

          <div className="branch-buttons">
            <button
              onClick={() => handleTabClick("users")}
              className={
                activeTab === "users" ? "branch-button active" : "branch-button"
              }
            >
              ผู้ใช้งาน
            </button>
            <button
              onClick={() => handleTabClick("poles")}
              className={
                activeTab === "poles" ? "branch-button active" : "branch-button"
              }
            >
              เสาไฟ
            </button>
          </div>
          <div className="search-bar">
            <img src={search} alt="search" className="search-user" />
            <input
              type="text"
              placeholder={
                activeTab === "users"
                  ? "ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
                  : "ค้นหารหัสเสา, ชื่อเสา, หรือสถานที่ติดตั้ง"
              }
              onChange={handleSearchInputChange}
            />
          </div>

          {activeTab === "users" && (
            <div className="length">
              <span>ผู้ใช้งานทั้งหมด </span>
              <span className="allBranches">{branch.usercount}</span>
              <span> คน</span>
            </div>
          )}

          {activeTab === "poles" && (
            <div className="length">
              <span>เสาหลักทั้งหมด </span>
              <span className="allBranches">{branch.masterpolescount}</span>
              <span> เสา </span>
              ||
              <span> เสารองทั้งหมด </span>
              <span className="allBranches"> {branch.slavepolescount}</span>
              <span> เสา</span>
            </div>
          )}

          {activeTab === "users" && (
            <div className="userTablee">
              {currentDataUsers.length > 0 ? (
                <table className="branch-table">
                  {/* ส่วนของส่วนหัวตาราง */}
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>ชื่อ</th>
                      <th>หมายเลขโทรศัพท์</th>
                      <th>อีเมล</th>
                      <th>สถานะการใช้งาน</th>
                    </tr>
                  </thead>
                  {/* ส่วนของข้อมูลในตาราง */}
                  <tbody>
                    {currentDataUsers.map((user, index) => (
                      <tr key={user.id}>
                        {/* ข้อมูลแต่ละแถว */}
                        <td>
                          {(currentPageUsers - 1) * itemsPerPage + index + 1}
                        </td>
                        <td>{user.name}</td>
                        <td>{user.phone_no}</td>
                        <td>{user.email}</td>
                        <td className="w50">
                          <UserStatus isOnline={user.active} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>ไม่มีข้อมูล</p>
              )}
            </div>
          )}

          {activeTab === "poles" && (
            <div className="userTablee">
              {currentDataPoles.length > 0 ? (
                <table className="branch-table">
                  {/* ส่วนของส่วนหัวตาราง */}
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>รหัสเสา</th>
                      <th>ชื่อเสา</th>
                      <th>เสารอง</th>
                      <th>สถานที่ติดตั้ง</th>
                      <th>สถานะการใช้งาน</th>
                    </tr>
                  </thead>
                  {/* ส่วนของข้อมูลในตาราง */}
                  <tbody>
                    {currentDataPoles.map((pole, index) => (
                      <tr key={pole.id}>
                        {/* ข้อมูลแต่ละแถว */}
                        <td>
                          {(currentPagePoles - 1) * itemsPerPage + index + 1}
                        </td>
                        <td>{pole.code}</td>
                        <td>{pole.name}</td>
                        <td>
                          <span
                            className="poleCount"
                            onClick={() => openSlavePolesModal(pole.id)}
                          >
                            {pole.slave_poles_count}{" "}
                            <img src={eyeOpen} alt="" />
                          </span>
                        </td>
                        <td>{pole.location}</td>
                        <td className="w50">
                          <UserStatus isOnline={pole.active} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p>ไม่มีข้อมูล</p>
              )}
            </div>
          )}

          {isSlavePolesModalOpen && poleDetails && (
            <div className="modal-background-fixedmodel">
              <div id="myModal" className="modal-content-pole">
                {" "}
                <span className="close" onClick={closeSlavePolesModal}>
                  &times;
                </span>
                <div className="titleMasterPole">
                  {" "}
                  <div className="h30">
                    <span>เสาหลัก</span>
                  </div>
                  <div className="w50">
                    <UserStatus isOnline={poleDetails.active} />
                  </div>
                </div>
                <div className="gridPole6">
                  <p className="gridPole">
                    รหัสเสาหลัก{" "}
                    <strong className="colorGridPole">
                      {poleDetails.code}
                    </strong>
                  </p>
                  <p className="gridPole">
                    ชื่อเสาหลัก
                    <strong className="colorGridPole">
                      {poleDetails.name}
                    </strong>
                  </p>
                  <div className="gridPole">
                    <label>{poleDetails.location}</label>

                    <p>
                      <label>{poleDetails.lat}</label>,
                      <label>{poleDetails.lng}</label>
                    </p>
                  </div>
                  <p className="gridPole">
                    รหัสอุปกรณ์ <strong>{poleDetails.hardware_id}</strong>
                  </p>
                  <p className="gridPole">
                    เวอร์ชัน Firmware{" "}
                    <strong>{poleDetails.firmware_version}</strong>
                  </p>
                  <p className="gridPole">
                    วันที่ติดตั้งเสา:{" "}
                    <strong>
                      {new Date(poleDetails.created_on).toLocaleDateString(
                        "en-GB"
                      )}
                    </strong>
                  </p>
                </div>
                <label>
                  เสารองทั้งหมด{" "}
                  <strong className="colorGridPole2">
                    {poleDetails.slave_poles
                      ? poleDetails.slave_poles.length
                      : 0}
                  </strong>{" "}
                  เสา
                </label>
                <div className="searcBar">
                  <input
                    type="text"
                    placeholder="ค้นหาชื่อเสา รหัสเสา"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input" // Ensure you have appropriate styling for this class
                  />
                </div>
                {poleDetails.slave_poles &&
                poleDetails.slave_poles.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>รหัสเสา</th>
                        <th>ชื่อเสา</th>
                        <th>สถานที่ติดตั้ง</th>
                        <th>พิกัด</th>
                        <th className="w50">สถานะการใช้งาน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {poleDetails.slave_poles
                        .filter((pole) => {
                          // Convert to lowercase for case-insensitive comparison
                          const term = searchTerm.toLowerCase();
                          return (
                            pole.name.toLowerCase().includes(term) ||
                            pole.code.toLowerCase().includes(term) ||
                            pole.location.toLowerCase().includes(term)
                          );
                        })
                        .slice(
                          (currentSlavePolePage - 1) * slavePolesPerPage,
                          currentSlavePolePage * slavePolesPerPage
                        )
                        .map((pole, index) => (
                          <tr key={index}>
                            <td>
                              {(currentSlavePolePage - 1) * slavePolesPerPage +
                                index +
                                1}
                            </td>
                            <td>{pole.code}</td>
                            <td>{pole.name}</td>
                            <td>{pole.location}</td>
                            <td>{`${pole.lat}, ${pole.lng}`}</td>
                            <td>
                              <UserStatus isOnline={pole.active} />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No slave poles found.</p>
                )}
                <div className="paginationPole">
                  {currentSlavePolePage > 1 && (
                    <button
                      onClick={() =>
                        setCurrentSlavePolePage((prev) => prev - 1)
                      }
                    >
                      &laquo;
                    </button>
                  )}
                  {poleDetails.slave_poles.length >
                    currentSlavePolePage * slavePolesPerPage && (
                    <button
                      onClick={() =>
                        setCurrentSlavePolePage((prev) => prev + 1)
                      }
                    >
                      &raquo;
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === "users" && filteredUsers.length > itemsPerPage && (
            <div className="paginationUp">
              <div className="pagination">
                {currentPageUsers > 1 && (
                  <button onClick={goToPreviousPageUsers}>&laquo;</button>
                )}

                {filteredUsers.length > currentPageUsers * itemsPerPage && (
                  <button onClick={goToNextPageUsers}> &raquo;</button>
                )}
              </div>{" "}
            </div>
          )}

          {activeTab === "poles" && filteredPoles.length > itemsPerPage && (
            <div className="paginationUp">
              <div className="pagination">
                {currentPagePoles > 1 && (
                  <button onClick={goToPreviousPagePoles}>&laquo;</button>
                )}

                {filteredPoles.length > currentPagePoles * itemsPerPage && (
                  <button onClick={goToNextPagePoles}> &raquo;</button>
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        <p>ไม่พบข้อมูลสาขา</p>
      )}
    </div>
  );
}

export default BranchDetails;
